class NavInternal {

    constructor() {
        const nav = document.querySelector('.nav-internal');
        const footer = document.querySelector('.nav-pre-footer');
        if (!nav) {
            return;
        }

        let mm = gsap.matchMedia();
        mm.add("(min-width: 768px)", () => {
            // Code spécifique pour les écrans de taille inférieure à 600px

            let st = ScrollTrigger.create({
                trigger: ".nav-internal",
                pin: ".nav-internal ul",
                start: "top top",
                endTrigger: ".nav-pre-footer",
                end: "top bottom",
            });
        });

        const links = nav.querySelectorAll("a");
        const sections = document.querySelectorAll("[data-section-name]");

        // links.forEach(link => {
        //     const anchor = link.getAttribute("href");
        //     const target = document.getElementById(anchor.substring(1));
        //
        //     link.addEventListener("click", (e) => {
        //         const  offset = document.querySelector('.header-main').offsetHeight;
        //         e.preventDefault();
        //         console.log(anchor);
        //         smoother.scrollTo(anchor, true, `top ${offset}`);
        //     });
        // });

        sections.forEach((section, i) => {
            const name = section.dataset.sectionName;
            const loopLast = i + 1 === sections.length;
            ScrollTrigger.create({
                trigger: section,
                start: "top center",
                endTrigger: () => { return loopLast ? section : sections[i + 1]; },
                end: () => { return loopLast ? "max" : "top center"; },
                onToggle: self => {
                    links.forEach(link => {
                        if (link.getAttribute("href") === `#${name}` && self.isActive) {
                            link.classList.add("current");
                        } else {
                            link.classList.remove("current");
                        }
                    });
                }
            });
        });
    }
}